/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Byznys_Na_ProdejInputs */

const cs_enum_byznys_na_prodej = /** @type {(inputs: Enum_Byznys_Na_ProdejInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byznys na prodej`)
};

const en_enum_byznys_na_prodej = /** @type {(inputs: Enum_Byznys_Na_ProdejInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byznys na prodej`)
};

/**
* | output |
* | --- |
* | "Byznys na prodej" |
*
* @param {Enum_Byznys_Na_ProdejInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_byznys_na_prodej = /** @type {((inputs?: Enum_Byznys_Na_ProdejInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Byznys_Na_ProdejInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_byznys_na_prodej(inputs)
	return cs_enum_byznys_na_prodej(inputs)
});